/** Client Portal v2 (2026-09, Phase 1, §1) — presentation-only status label helpers, mirroring
 * kernel/client_serializer.py's CLIENT_STATUS_LABELS. The backend already attaches
 * `status_label`/`is_active` to every project it returns; these helpers exist for the couple of
 * spots (year/category filters) that need to reason about the label independent of a fetched
 * project object. */
export const ACTIVE_LABEL_ORDER = ["Confirmed", "Pre-production", "Production", "Post-production"];
export const COMPLETED_LABEL_ORDER = ["Completed", "Past project"];

export function projectYear(project) {
  const sd = project.shoot_dates;
  // Production bug fix (2026-10) — `shoot_dates` can be the raw {start,end} object this app's
  // own date-range picker produces (see utils/formatShootDates.js); `String({...})` silently
  // stringifies to "[object Object]" (no crash here, but the year regex below would then
  // never match, so the project got miscategorized). Pull a real ISO string out of either shape.
  const raw = (typeof sd === "string" ? sd : (sd && typeof sd === "object" ? (sd.start || sd.end) : null)) || project.created_at || "";
  const m = String(raw).match(/(20\d{2})/);
  return m ? m[1] : null;
}
